import React, { useRef, useState } from "react";

import theme from '../../../../config/theme';

import Icon from 'react-icons-kit';
import { chevronDown, chevronUp } from 'react-icons-kit/feather';
import CategoryFilterBlock from './CategoryFilterBlock';
import CheckboxFilterBlock from './CheckboxFilterBlock';
import ShowMore from "./ShowMore";


const FilterBlock = (props) => {
    const [open, setOpen] = useState(true);
    const [expanded, setExpanded] = useState(false);

    const containerEl = useRef(null);

    const toggleMore = () => {
        setExpanded(!expanded);
    }

    const openPanel = () => {
        setOpen(true);
    }

    const closePanel = () => {
        setOpen(false);
    }

    if(props.options.length === 0) {
        return null;
    }

    const onChange = (e) => {
        props.onChange(e);

        if(containerEl.current) {
            containerEl.current.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'});
        }
    }

    return (
        <div className="filter-block-wrapper">
            <style jsx>{`
                .filter-block-wrapper {
                    background-color: ${theme.colors.base.white};
                    margin: 5px;
                    margin-bottom: 10px;
                    border-radius: 5px;

                    ${props.type === "checkbox" ? `
                    box-shadow: 0px 0px 7px #EEEEEE;
                    border: 1px solid #DDDDDD;
                    ` : ''}

                    box-sizing: border-box;
                }

                .filter-block-header {
                    background-color: ${theme.colors.base.white};
                    color: ${theme.colors.base.base};
                    padding: 5px;
                    margin-left: 10px;
                    margin-right: 10px;
                    margin-top: 5px;
                    display: flex;
                    justify-content: space-between;
                }

                .filter-block-title {
                    font-size: 1.2em;
                    font-weight: 400;
                }

                .filter-block-toggle {
                    display: none;
                    cursor: pointer;
                }

                .filter-block-toggle.show {
                    display: block;
                }

                .filter-block-content-wrapper {
                    max-height: 0px;
                    overflow: hidden;
                    transition: all 0.2s;

                }

                .filter-block-content-wrapper.show {
                    max-height: ${props.type !== 'categories' ? '300px' : '1500px'};
                }

                .filter-block-content {
                    padding: 0 10px;
                    max-height: ${props.type !== 'categories' ? '300px' : '1500px'};
                    box-sizing: border-box;
                    overflow-y: auto;
                }
            `}</style>
            {props.type === "checkbox" ?
                <div className="filter-block-header">
                    <div className="filter-block-title">
                        {props.title}
                    </div>
                    <div className={`filter-block-toggle ${open ? '' : 'show'}`} onClick={openPanel}>
                        <Icon size={24} icon={chevronDown}/>
                    </div>

                    <div className={`filter-block-toggle ${open ? 'show' : ''}`} onClick={closePanel}>
                        <Icon size={24} icon={chevronUp}/>
                    </div>
                </div> : null}


            <div className={`filter-block-content-wrapper ${open ? 'show' : ''}`}>
                    <div className={`filter-block-content`} ref={containerEl}>
                        {props.type === "checkbox" ?
                                    <CheckboxFilterBlock enabled={props.enabled} id={props.id} options={props.options} onChange={onChange} expanded={expanded}/>
                            : null
                        }

                        {props.type === "categories" ?
                            <CategoryFilterBlock view={props.view} enabled={props.enabled} id={props.id} options={props.options} onChange={props.onChange}/> : null
                        }

                    </div>

            </div>

            <div className={`filter-block-content-wrapper ${open ? 'show' : ''}`}>
                {props.type === "checkbox" && props.options.length > 6 ?
                    <ShowMore expanded={expanded} toggleMore={toggleMore}/>
                : null}
            </div>

        </div>
    )
}

export default FilterBlock;
